import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input, Dropdown, MenuItem, DropdownButton } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import axios from 'axios';
import moment from 'moment';
import CashFormatter from '../Common/cashFormatter';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { Bar } from 'react-chartjs-2';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

const isMMD = ROOT_API_URL === "https://mmdavis-scm.truckxi.com/api/" || ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/';

const { Selectors } = Data;

export class POSGraphModal extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,



            graphType: 'Hour',
            hourDate: null,
            fromDate: null,
            toDate: null,

            totalCustomers: 0,
            totalRevenue: 0,
        }
    }

    componentDidMount() {
        // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
        //     if (response.data) {
        //         this.initializeModal(response.data);
        //     }
        // }, (err) => {
        //     if (err.status === 500 || err.status === 404) {
        //         alert("Server error, please refresh page. If problem persists, contact administrator.");
        //     }
        // });

        this.state.hourDate = new Date();
        this.fetchGraphData();

        // axios({
        //     method: 'GET',
        //     url: url,
        //     headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        // })
        //     .then(res => {
        //         this.setState({
        //             rows: res.data.Sales_Order_Lines,
        //             selectedRows: [],
        //             editedRows: [],
        //         });
        //     }, err => {
        //     })
    }

    componentWillReceiveProps(nextProps) {
    }

    // initializeModal = (array) => {
    //     let index = 0;
    //     let formatter = [];
    //     if (array && array.length > 0) {
    //         array.map(r => {
    //             formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
    //         })
    //     } else {
    //         formatter.push({ Idx: 0, name: "", note: "" });
    //     }
    //     this.setState({
    //         rows: formatter,
    //         selectedRows: [],
    //         editedRows: [],
    //     });
    // }

    fetchGraphData = () => {
        const { graphType, hourDate, fromDate, toDate } = this.state;
        let from = null;
        let to = null;

        if (graphType === 'Day' && fromDate && toDate) {
            from = moment(fromDate).startOf('day').toISOString();
            to = moment(toDate).endOf('day').toISOString();
        } else if (graphType === 'Hour') {
            from = moment(hourDate).startOf('day').toISOString();
            to = moment(hourDate).endOf('day').toISOString();
        } else {
            return;
        }

        this.state.totalCustomers = 0;
        this.state.totalRevenue = 0;

        let url = `${ROOT_URL}v1/pos/order_revenue_report?Type=${graphType}&StartDate=${from}&EndDate=${to}`;
        axios({
            method: 'GET',
            url: url,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                let sortData = [];
                let tempTime = "";
                res.data.map((r, i) => {
                    this.state.totalCustomers = this.state.totalCustomers + r.Customers;
                    this.state.totalRevenue = this.state.totalRevenue + r.Revenue;
                    if (graphType === 'Hour') {
                        if (i * 100 < 1000) {
                            tempTime = '0' + i + ':00';
                            tempTime = moment(tempTime, 'HH:mm').format('hh:mm a');
                            sortData.push({ ...r, HourTime: tempTime, Revenue: r.Revenue ? r.Revenue.toFixed(2) : 0 });
                        } else {
                            tempTime = i + ':00';
                            tempTime = moment(tempTime, 'HH:mm').format('hh:mm a');
                            sortData.push({ ...r, HourTime: tempTime, Revenue: r.Revenue ? r.Revenue.toFixed(2) : 0 });
                        }
                    } else {
                        tempTime = moment(r.Date).format("MM-DD-YY");
                        sortData.push({ ...r, Date: tempTime, Revenue: r.Revenue ? r.Revenue.toFixed(2) : 0 });
                    }
                });

                this.setState({
                    rows: sortData,
                    selectedRows: [],
                    editedRows: [],
                });
            }, err => {
            })
    }

    handleOnSave = (e) => {
        e.preventDefault();
        this.state.rows.map((r) => {
            // r.recreate = false;
        });
        if (this.state.selectedRows.length < 1) {
            alert("At least one product is required.");
            return;
        }
        let tempArray = [];
        let tempString = "";
        if (this.state.selectedRows && this.state.selectedRows.length > 0) {
            this.state.selectedRows.map(r => {
                tempArray.push(r.SalesOrderLine_id);
            });
            tempString = tempArray.join(',');
        }
        // this.props.printSalesOrderLabelDSQ(tempString);
        // this.props.updateFJAgents(this.props.fjCustomerId, this.state.rows).then((response) => {
        //     // alert(JSON.stringify(response.data));
        //     alert("Agents Saved");
        //     this.props.closeAgentModal();
        //   }, (err) => {
        //     if (err.status === 500 || err.status === 404) {
        //       alert(JSON.stringify(err.data));
        //     }
        //   });
        // this.props.onSave(this.state.rows);
    }

    shiftLeft(arr) {
        let first = arr.shift();
        arr.push(first);
        return arr;
    }


    renderGraph() {
        const { rows, graphType } = this.state;
        // const rand = () => Math.round(Math.random() * 20 - 10);

        let dataC = [];
        let dataR = [];

        let labels = [];

        if (rows) {
            rows.map(r => {
                dataC.push(r.Customers);
                dataR.push(r.Revenue);
                if (graphType === 'Hour') {
                    labels.push(r.HourTime);
                } else {
                    labels.push(r.Date);
                }

            });
        }

        if (isMMD && graphType === 'Hour') {
            dataC.splice(2, 6);
            dataR.splice(2, 6);
            labels.splice(2, 6);
            dataC = this.shiftLeft(dataC);
            dataR = this.shiftLeft(dataR);
            labels = this.shiftLeft(labels);
            dataC = this.shiftLeft(dataC);
            dataR = this.shiftLeft(dataR);
            labels = this.shiftLeft(labels);
        }

        const data = {
            labels: labels,
            datasets: [
                {
                    type: 'line',
                    label: 'Net Revenue',
                    borderColor: 'rgb(54, 162, 235)',
                    borderWidth: 2,
                    fill: false,
                    data: dataR,
                    yAxisID: 'y-axis-2',
                },
                {
                    type: 'bar',
                    label: 'Customers',
                    backgroundColor: '#ff8b3d',
                    data: dataC,
                    borderColor: 'white',
                    borderWidth: 2,
                    yAxisID: 'y-axis-1',
                },
            ],
        };

        let options = {
            scales: {
                yAxes: [
                    {
                        scaleLabel: { display: true, labelString: 'Customers', fontColor: 'rgb(220, 147, 76)' },
                        type: 'linear',
                        display: true,
                        position: 'right',
                        id: 'y-axis-1',
                        gridLines: { display: false }
                    },
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-2',
                        text: 'Revenue',
                        scaleLabel: { display: true, labelString: 'Net Revenue', fontColor: 'rgb(54, 162, 235)' },
                        gridLines: { display: false }
                    },
                ],
            },
        };

        return (
            <Row>
                <Col xs={12} style={{ marginTop: '20px' }}>
                    <Bar data={data} options={options} />
                </Col>
            </Row>
        )
    }


    renderAgentTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleRowUpdated = e => {
            this.setState({ sortColumn: null, sortDirection: null })
            let rows = getRows();
            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            editedRows.forEach((element, index) => {
                if (element.Idx === rows[e.rowIdx].Idx)
                    editedRows.splice(index, 1)
            }, this);
            editedRows.push(rows[e.rowIdx]);
            this.setState({
                rows: rows,
                editedRows: editedRows,
            });
        }
        // const onRowsSelected = (rows) => {
        //     let newRows = getRows();
        //     newRows.map(r => {
        //         r.isSelected = false;
        //     })
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = true;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
        // }
        const onRowsSelected = (rows) => {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            rows.map(r => {
                newRows[r.rowIdx].isSelected = true;
                selectedRows.push(r.row);
            });
            this.setState({ rows: newRows, selectedRows });
        }
        // const onRowsDeselected = (rows) => {
        //     let newRows = getRows();
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = false;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [] });
        // }
        const onRowsDeselected = (rows) => {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
                const rowIndex = selectedRows.indexOf(r.row);
                selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows });
        }

        const handleGridSort = (sortColumn, sortDirection) => {
            var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState(state);
        }

        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
        }

        const SecondsDateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                    const date = moment(this.props.value).format("MM-DD-YY HH:mm");
                    return <span>{date}</span>;
                }
                return <span className="label label-danger">-</span>;
            },
        });

        const columns = [

            ...this.state.graphType === 'Hour' ? [
                {
                    key: "HourTime",
                    name: <Translate value="hour" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                    filterable: true,
                }
            ] : [
                {
                    key: "Date",
                    name: <Translate value="date" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                    filterable: true,
                },
            ],
            {
                key: "Customers",
                name: <Translate value="customers" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: "Revenue",
                name: <Translate value="net_revenue" />,
                resizable: true,
                sortable: true,
                width: 110,
                filterable: true,
                formatter: ({ value }) => (
                    <div style={{ width: "100%", height: "100%", textAlign: "center" }}>
                        ${value}
                    </div>
                ),
            },
        ];

        const onRowClick = (rowIdx, row) => {
            if (rowIdx !== -1) {
                const rows = getRows();
                rows.map((r) => {
                    r.isSelected = false;
                });
                const selectedRows = [rows[rowIdx]];
                rows[rowIdx].isSelected = true;
                //   const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
                //   this.setState({ salesOrders });
                //   this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
                let temp = {
                    rows: [],
                    selectedRows: null,
                    editedRows: [],
                    filters: {},
                };
                if (selectedRows && selectedRows[0]) {
                    temp.rows = selectedRows[0].lines;
                    this.setState({ details: temp });
                }
            }
        };

        return (
            <Row>
                <Col xs={12}>
                    <div>
                        <ReactDataGrid
                            // rowKey="Idx"
                            // enableCellSelect={true}
                            onGridSort={handleGridSort}
                            onAddFilter={handleFilterChange}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={420}
                            rowHeight={25}
                            headerRowHeight={45}
                            toolbar={<Toolbar enableFilter />}
                        // enableRowSelect='single'
                        // onRowUpdated={handleRowUpdated}
                        // rowSelection={{
                        //     showCheckbox: true,
                        //     onRowsSelected,
                        //     onRowsDeselected,
                        //     selectBy: {
                        //         isSelectedKey: 'isSelected'
                        //     }
                        // }}
                        // onRowClick={onRowClick}
                        />
                    </div>
                </Col>
            </Row>
        )
    }



    render() {
        const {
        } = this.props;

        const { graphType, hourDate, fromDate, toDate, totalCustomers, totalRevenue
        } = this.state;

        let from = null;
        let to = null;
        if (graphType === 'Day' && fromDate && toDate) {
            from = moment(fromDate).startOf('day').toISOString();
            to = moment(toDate).endOf('day').toISOString();
        } else if (graphType === 'Hour') {
            from = moment(hourDate).startOf('day').toISOString();
            to = moment(hourDate).endOf('day').toISOString();
        }
        const params = `Type=${graphType}&StartDate=${from}&EndDate=${to}`;
        const token = localStorage.getItem('token');
        let excelURL = `${ROOT_URL}v1/pos/order_revenue_report?${params}&Bearer=${token}&action=excel`;
        let isExcelDisabled = false;
        if (graphType === 'Day' && (!fromDate || !toDate)) {
            isExcelDisabled = true;
        } else if (graphType === 'Hour' && (!hourDate)) {
            isExcelDisabled = true;
        }

        const graphTypeOptions = [
            {
                label: 'Hour',
                value: 'Hour',
            },
            {
                label: 'Day',
                value: 'Day',
            },
        ];

        const graphTypeChange = (e) => {
            console.log("graphType", e.value);
            this.setState({ graphType: e.value, totalCustomers: 0, totalRevenue: 0, hourDate: null, fromDate: null, toDate: null, rows: [] });
        }

        const hourDateChange = (e) => {
            let { hourDate } = this.state;
            console.log("hour", e);
            this.setState({ hourDate: e });
            this.state.hourDate = e;
            this.fetchGraphData();
        }

        const fromDateChange = (e) => {
            let { toDate, fromDate } = this.state;
            console.log("from", e);
            if (toDate && e > toDate) {
                alert("Selection must be earlier than ending date.");
                return;
            }
            if (moment(toDate).diff(moment(e), 'days') > 31) {
                alert("Time difference limit of 30 days.");
                return;
            }
            this.setState({ fromDate: e });
            this.state.fromDate = e;
            this.fetchGraphData();
        }

        const toDateChange = (e) => {
            let { toDate, fromDate } = this.state;
            console.log("to", e);
            if (fromDate && e < fromDate) {
                alert("Selection must be later than starting date.");
                return;
            }
            if (moment(e).diff(moment(fromDate), 'days') > 31) {
                alert("Time difference limit of 30 days.");
                return;
            }
            this.setState({ toDate: e });
            this.state.toDate = e;
            this.fetchGraphData();
        }

        return (
            <Row>
                <Col xs={12}>


                    <label className="col-xs-1" style={{ textAlign: 'right', marginTop: '3px' }}><Translate value="graph_type" />:</label>
                    <div className="col-xs-1" >
                        <Dropdown>
                            <Dropdown.Toggle style={{ height: '24px', width: '100px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                                {graphType ? graphType : 'SELECT'}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="super-colors">
                                {graphTypeOptions.map(el => {
                                    return (
                                        <MenuItem onClick={() => graphTypeChange(el)}>{el.label}</MenuItem>
                                    )
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>

                    <label className="col-xs-1" style={{ textAlign: 'right', marginTop: '3px' }}><Translate value="date" />:</label>
                    {
                        (graphType === 'Hour') &&
                        <div className="col-xs-2" >
                            <DateTimePicker
                                id="all-register-datepicker"
                                format="MM-DD-YY"
                                // max={Today}
                                // step={10}
                                onChange={(e) => {
                                    hourDateChange(e)
                                }}
                                time={false}
                                value={hourDate}
                            />
                        </div>
                    }

                    {
                        (graphType === 'Day') &&
                        <div className="col-xs-2" >
                            <DateTimePicker
                                id="all-register-datepicker"
                                format="MM-DD-YY"
                                // max={Today}
                                // step={10}
                                onChange={(e) => {
                                    fromDateChange(e)
                                }}
                                time={false}
                                value={fromDate}
                            />
                        </div>
                    }
                    {
                        (graphType === 'Day') &&
                        <label className="col-xs-1" style={{ width: '40px', textAlign: 'center', marginTop: '3px' }}>to</label>
                    }
                    {
                        (graphType === 'Day') &&
                        <div className="col-xs-2">
                            <DateTimePicker
                                id="all-register-datepicker"
                                format="MM-DD-YY"
                                // max={Today}
                                // step={10}
                                onChange={(e) => {
                                    toDateChange(e)
                                }}
                                time={false}
                                value={toDate}
                            />
                        </div>
                    }


 <div className="col-xs-1" style={{marginLeft: '20px'}}>
<Button
            bsStyle='success'
            className="export-to-excel"
            // type='button'
            disabled={isExcelDisabled}
            href={excelURL}
          >
            <em className='fa fa-download' />
            <Translate value="excel" />
          </Button>
          </div>


                    {/* <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button>
                </ButtonToolbar> */}
                    <Row>
                        <Col xs={9} className="text-center">
                            <div style={{ padding: '0px 0px' }}>
                                {this.renderGraph()}
                            </div>
                        </Col>
                        <Col xs={3} className="text-center">
                            <div style={{ padding: '0px 0px' }}>
                                {this.renderAgentTable()}
                                <div style={{ fontSize: '12px', marginTop: '3px', padding: '0px 5px', justifyContent: 'space-between', display: 'flex'}}>
                                    <p>Total Customers: <span style={{color: 'rgb(220, 147, 76)', fontWeight: 'bold'}}>{totalCustomers}</span></p>
                                    <p>Total Revenue: <span style={{color: 'rgb(220, 147, 76)', fontWeight: 'bold'}}>${totalRevenue ? totalRevenue.toFixed(2) : 0}</span></p>
                                </div>
                            </div>
                        </Col>
                    </Row>


                    {/* <Row className="centerStyle" style={{ marginTop: '15px' }}>
                        <Button
                            style={{ marginRight: '5px' }}
                            bsStyle="success"
                            onClick={(e) => { this.handleOnSave(e); }}
                        >
                            <em className="fa fa-print" />
                            <Translate value="print_label" />
                        </Button>
                    </Row> */}
                </Col>
            </Row>

        );
    }
}

export default POSGraphModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/posGraphModal.jsx